import {
    getDatabase,
    ref,
    set,
    push,
    onValue,
    remove,
    update,
} from "firebase/database";
import { useEffect, useState } from 'react';
import firebase from './firebase';

//READ PRODUCTS
export const useFetch = (address) => {
    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const db = getDatabase(firebase);
        const productsRef = ref(db, `/${address}`);

        onValue(productsRef, (snapshot) => {
            const data = snapshot.val();
            const productsArray = [];

            for (let id in data) {
                productsArray.push({ id, ...data[id] });
            }
            setProducts(productsArray);
            setIsLoading(false);
        });
    }, []);
    return { isLoading, products };
}

//READ PRODUCTS CHECKOUT
export const useFetchCheckout = () => {
    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const db = getDatabase(firebase);
        const productsRef = ref(db, `/checkout`);

        onValue(productsRef, (snapshot) => {
            const data = snapshot.val();
            const productsArray = [];

            for (let id in data) {
                productsArray.push({ id, ...data[id] });
            }
            setProducts(productsArray);
            setIsLoading(false);
        });
        // console.log(products);
    }, []);
    return { isLoading, products };
}

//DELETE PRODUCT
export const DeleteProduct = (id, address) => {
    const db = getDatabase(firebase);
    remove(ref(db, `/${address}/` + id));
}

//DELETE CHECKOUT
export const DeleteCheckout = (phone) => {
    const db = getDatabase(firebase);
    remove(ref(db, `/checkout/${phone}`));
}

//UPDATE PRODUCT
// var johnRef = firebase.database().ref("players/John");
// johnRef.update({
//     "number": 10
// });

//CHECKOUT
export const Checkout = () => {
    const database = getDatabase(firebase);
    set(ref(database, `/checkout`), {})
}